import { makeRoleHash } from "../../database-strings";
import type { TableGlideType } from "../../description";
import { getEmailOwnersColumnNames } from "../../description";
import { assertNever, isArray, normalizeEmailAddress } from "../../Support";
import type { AppUserData } from "./data-row-store";

export function isRowOwnedByUser(
    appUserData: AppUserData | undefined,
    table: TableGlideType | undefined,
    getColumnValue: (columnName: string) => string | readonly string[] | undefined
): boolean {
    if (table === undefined) return true;

    const emailOwnersColumns = getEmailOwnersColumnNames(table, true);
    if (emailOwnersColumns.length === 0) return true;

    if (appUserData === undefined) return false;

    const { email, roles } = appUserData;

    function matches(s: string): boolean {
        if (normalizeEmailAddress(s) === email) return true;
        if (roles.size === 0) return false;
        const role = makeRoleHash(s);
        return role !== undefined && roles.has(role);
    }

    for (const columnName of emailOwnersColumns) {
        const emailOwners = getColumnValue(columnName);
        if (emailOwners === undefined) continue;
        if (typeof emailOwners === "string") {
            if (matches(emailOwners)) {
                return true;
            }
        } else if (isArray(emailOwners)) {
            for (const v of emailOwners) {
                if (matches(v)) {
                    return true;
                }
            }
        } else {
            assertNever(emailOwners);
        }
    }
    return false;
}
